import React,{useState,useEffect} from 'react';
import { Link, useParams  } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { useNavigate } from "react-router-dom";
import Popover from '../admin/shared/Popover';
import SucessMessage from './shared/SucessMessage';
import { StoreModel } from '../common/constants';

function AddModel() {

 const {modelId} = useParams(); 
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPopoverId, setSelectedPopoverId] = useState(null);

  useEffect(() => {
    if (modelId) {
      setIsEditMode(true);
      fetchModelData();
    }
  }, [modelId]);

  const fetchModelData = async () => {
    try {
      console.log('Fetching model data for ID:', modelId);
      const response = await axios.get(`${config.backendUrl}/admin/models/${modelId}`, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      });
      
      console.log('Model data response:', response.data);
      const modelData = response.data.data[0];
      
      // Set form data with existing model name
      setFormData({
        model: modelData.model,
        image: null // Keep as null since we're not uploading the existing image
      });
      
      // Set preview image from existing imageUrl
      if (modelData.imageUrl) {
        setPreviewImage(modelData.imageUrl);
      }
      
    } catch (error) {
      console.error('Error fetching model:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
    }
  };

  const [formData,setFormData] = useState({
    model:"",
    image: null
  });
  const [errors,setErrors] = useState({
    model: '',
    image: ''
  });
  const [previewImage, setPreviewImage] = useState(null);
 
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "model") {
      // Restrict max length to 20 characters
      if (value.length > 20) return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
     // Clear error while typing
    if (name === "model") {
      setErrors((prev) => ({ ...prev, model: "" }));
    }
  };
  

  const handleClosePopover = () => {
  
    setSelectedPopoverId(false);

    navigate("/admin/models");
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    let newErrors = { model: "", image: "" };
    let hasError = false;

    if (!formData.model) {
      newErrors.model = "Please enter a model name";
      hasError = true;
    }else if (formData.model.length < 3) {
      newErrors.model = "Model name must be at least 3 characters long";
      hasError = true;
    } else if (formData.model.length > 20) {
      newErrors.model = "Model name cannot exceed 20 characters";
      hasError = true;
    }

    if (!isEditMode && !formData.image) {
      newErrors.image = "Please upload an image";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    // Only include image if user selected a new one
    const dataToSend = {
      model: formData.model,
      ...(isEditMode && { id: modelId }),
      ...(formData.image && { image: formData.image })
    };

    console.log('Submitting data:', {
      model: formData.model,
      hasImage: !!formData.image,
      isEditMode,
      modelId
    });

    try {
      const url = isEditMode 
        ? `${config.backendUrl}/admin/model/edit/${modelId}` 
        : StoreModel;
      
      const method = isEditMode ? 'post' : 'post';
      
      console.log('API call:', method, url);
      
      // Use FormData if image is present, otherwise use JSON
      const requestData = formData.image ? (() => {
        const formDataToSend = new FormData();
        formDataToSend.append('model', formData.model);
        formDataToSend.append('image', formData.image);
        if (isEditMode) formDataToSend.append('id', modelId);
        return formDataToSend;
      })() : dataToSend;

      const headers = {
        'token': localStorage.getItem('token'),
        'Content-Type': formData.image ? 'multipart/form-data' : 'application/json',
      };
      
      await axios[method](url, requestData, { headers });
      
      setSelectedPopoverId(true);
    } catch (error) {
      console.error('Submit error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
      if (error.response?.status === 409) {
        setErrors({ ...newErrors, model: "Model name already exists" });
      } else if (error.response?.status === 400) {
        setErrors({ ...newErrors, model: "Invalid request. Please check your input." });
      } else {
        console.error('Error:', error);
      }
    }
  };

  const handleImageChange = (event) => {
  const selectedFile = event.target.files[0];

  if (!selectedFile) {
    return;
  }
    setErrors({ ...errors, image: "" });
  // 1. File type check
  const validTypes = ["image/jpeg", "image/jpg", "image/png"];
  if (!validTypes.includes(selectedFile.type)) {
    setErrors({ ...errors, image: "Only JPG, JPEG, or PNG files are allowed." });
    return;
  }

  // 2. File size check (example: max 2MB)
  const maxSize = 2 * 1024 * 1024; // 2 MB
  if (selectedFile.size > maxSize) {
    setErrors({ ...errors, image: "File size must be less than 2 MB." });
    return;
  }

  // 3. Optional: Validate image dimensions
  const img = new Image();
  img.onload = () => {
    if (img.width < 200 || img.height < 200) {
      setErrors({ ...errors, image: "Image must be at least 200x200 pixels." });
      return;
    }

    // If all validations pass
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedFile);

    setFormData({ ...formData, image: selectedFile });
    setErrors({ ...errors, image: "" });
  };
  img.src = URL.createObjectURL(selectedFile);
};





  return (
    <> 
    <div className="pt-[70px]"> 
      <h2>Models</h2>
      <div className="breadcrumbs">
        {" "}
        <Link to="/admin/dashboard">Home</Link>
          <span>{">"} </span> <Link to="/admin/models">Models</Link>
        <span>{">"} </span>Add Model{" "}
      </div>
      </div>

      <div className='whitebox uploadproductpop' >
      <div className="container mx-auto p-4">
      <div className="flex flexwrapcol -mx-2 lg:gap-10">
       
        {/* Column 1 */}
       
        <div className="w-full md:w-1/2 px-2 mb-4"> 
        <h2>{isEditMode ? 'Edit Model' : 'Add Model'}</h2>
        <p className='mb-3'>{isEditMode ? 'Update Model Details' : 'Add to Create Model'}</p>
        <form onSubmit={handleSubmit}>
          <div className="flex items-center mb-6">
          <label className="block text-sm   leading-5  w-1/2" htmlFor="modelName">
            Model Name
          </label>
         <div className="block w-full "> <input name="model"  value={formData.model}  onChange={handleInputChange} className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline" />
          {errors.model && <p style={{ color: 'red' }}>{errors.model}</p>}
          </div>
          </div>

          <div className="flex items-center mb-6">
        <label className="block text-sm   leading-5 w-1/2">Add Image</label>
        <div className="block relative w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
          <input
            type="file" name="image"
            onChange={handleImageChange} 
            accept=".jpg,.jpeg,.png"
            style={{ opacity: "0", position:"absolute",width:"100%" }}
            id="file-upload"
          />
          <label htmlFor="file-upload" className="flex justify-between items-center">
         <div> {previewImage ? 'Change Image' : 'Upload Image'} </div>  
         <button style={{height:"20px", width:"100px"}} className='redbtn' type="button"> Browse</button>
          </label>
          {previewImage && (
            <div className="mt-2">
              <img src={previewImage} alt="Preview" style={{ maxWidth: "100%", maxHeight: "200px" }} />
              {isEditMode && !formData.image && <p className="text-sm text-gray-500">Current image</p>}
            </div>
          )}
           {errors.image && (
                <p style={{ color: 'red', marginTop: '5px', fontSize: '13px' }}>
                  {errors.image}
                </p>
             )}
        </div>
          </div>

          <div className="flex items-center mb-6">
            <label className="block text-sm   leading-5  w-1/2 "> 
            </label>
            <div  className="block w-full"> 
            <button className="redbtn" type="submit">
               Save
            </button>
          </div>
          </div>
          </form>
        </div>
     
     
      </div>
    </div>
      </div>
      {selectedPopoverId && (
          <Popover onClose={handleClosePopover}  isVisible={selectedPopoverId !== null}>
          
                    
       <SucessMessage>

          <h4>Model Added <br/> 
          Successfully</h4>
        </SucessMessage>

          </Popover>
        )}
    </ >
  )
}

export default AddModel
